<app-navbar title="Usuários">
  @if (userHasPermission('invite users')) {
    <p-button (click)="routeToUser()" pTooltip="Adicionar Usuário">
      <i class="fa-solid fa-plus"></i>
      <span class="font-bold hidden md:block">Adicionar usuário</span>
    </p-button>
  }
</app-navbar>

<div class="container m-auto py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <app-card>
    <app-card-header title="Usuários" />
    <app-table-users
      [loading]="loading()"
      (view)="routeToUser($event.id, true)"
      (edit)="routeToUser($event.id)"
      (enable)="enableUser($event)"
      (disable)="disableUser($event)"
      (delete)="deleteUser($event)"
    />
  </app-card>
</div>
